// extracted by mini-css-extract-plugin
module.exports = {"p":"FormSwap_p__PosJy","form":"FormSwap_form__bwlTQ","submit":"FormSwap_submit__3OrOo","arrow":"FormSwap_arrow__tW7Tu"};